<template>
  <div class="hero">
    <div class="hero__head">
      <hero-chapter v-if="!isInHome && !slideInTransition"/>
    </div>
    <div class="hero__body">
      <hero-title/>
    </div>
    <div class="hero__foot">
      <hero-discover v-if="isInHome && !slideInTransition"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { throttle } from 'lodash';
import HeroTitle from '@/components/HeroTitle.vue';
import HeroChapter from '@/components/HeroChapter.vue';
import HeroDiscover from '@/components/HeroDiscover.vue';

export default {
  name: 'Hero',
  components: {
    HeroDiscover,
    HeroChapter,
    HeroTitle,
  },
  data() {
    return {
      isInHome: this.$route.name === 'Home',
    };
  },
  computed: {
    ...mapState(['slideInTransition']),
  },
  watch: {
    $route(to) {
      this.isInHome = to.name === 'Home';
    },
  },
  methods: {
    ...mapMutations([
      'goNextPage',
      'heroWasCreated',
      'goPrevPage']),
    throttleTouchmove() {
      if (this.isInHome && !this.slideInTransition) this.goNextPage();
    },
    throttleWeel(ev) {
      if (this.isInHome && !this.slideInTransition) {
        if (ev.deltaY > 0) {
          this.goNextPage();
        } else if (ev.deltaY < 0) {
          this.goPrevPage();
        }
      }
    },
  },
  mounted() {
    this.heroWasCreated();
    this.$eventHub.$emit('heroMounted');

    this.$el.addEventListener(
      'touchmove',
      throttle(this.throttleTouchmove, 400),
      {
        capture: true,
        passive: true,
      },
    );
    this.$el.addEventListener(
      'wheel',
      throttle(this.throttleWeel, 300),
      {
        capture: true,
        passive: true,
      },
    );
  },
};
</script>

<style scoped lang="scss">
.hero {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__head,
  &__foot {
    flex-basis: 4rem;

    display: flex;
    justify-content: center;
    align-items: flex-end;

  }

  &__body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /*flex-basis: 56vw;*/


    @include mq(mobileL) {
      margin-bottom: 1rem;
      flex-basis: auto;
    }
  }

  &__title,
  &__subtitle {
    text-transform: uppercase;
  }
}
</style>
